import React from 'react';
import { Segment } from 'semantic-ui-react';
export default {
  React,
  Segment
};